import { withTheme } from "styled-components";
import DefaultTable, {
  Filter,
  Line,
} from "../../../ui-library/CustomTable/DefaultTable";
import React from "react";
import { Dropdown } from "react-bootstrap";
import TableDropDown from "../../../ui-library/TableDropDown/TableDropDown";
import CustomDropdown from "../../../ui-library/CustomDropdown/CustomDropdown";
import { useTranslation } from "react-i18next";
import {
  DateFormat,
  SurveyStatus,
  SurveyType,
} from "../../../../modules/constants";
import moment from "moment";

const SurveysTable = (props) => {
  const {
    getData,
    searchedParams,
    totalitems,
    surveys,
    canAnswerSurvey,
    canViewResults,
    role,
    handleAnswerSurvey,
    showSurveyResults,
  } = props;

  const { t } = useTranslation();
  const defaultProps = {
    headers: [
      { label: t("appText.surveysTable.survey.nextSteps") },
      { label: t("appText.surveysTable.expires.date") },
      { label: t("appText.surveysTable.estimated.time") },
      { label: t("appText.surveysTable.survey.completed") },
      { label: t("appText.surveysTable.survey.status") },
      { label: t("appText.surveysTable.survey.options") },
    ],
    hasSearch: 1,
    haspagesizefilter: 1,
    haspagination: 1,
    searchedParams,
    totalitems,
    getData,
    noDataText: t("appText.table.noResults"),
  };

  const canViewSurveyResults = (survey) => {
    if (!canViewResults) {
      return false;
    } else if (
      survey?.surveyType === SurveyType.PII_SURVEY.value &&
      !survey?.roles?.includes(role)
    ) {
      return false;
    } else {
      return true;
    }
  };

  const getDropDownItems = (survey) => {
    const dropDownMenuItems = {
      ANSWER_SURVEY: {
        text: t("appText.surveysTable.start.survey"),
        callBack: (survey) => handleAnswerSurvey(survey),
        id: 1,
        isVisible: canAnswerSurvey,
        isDisabled: [
          SurveyStatus.COMPLETED.value,
          SurveyStatus.EXPIRED.value,
        ].includes(survey?.status),
      },
      RESULTS: {
        text: t("appText.surveysTable.review.survey"),
        callBack: (survey) => showSurveyResults(survey),
        id: 2,
        isVisible: canViewSurveyResults(survey),
        isDisabled: survey?.status !== SurveyStatus.COMPLETED.value,
      },
    };

    return Object.values(dropDownMenuItems);
  };

  const filterByAccountStatus = (status) => {
    const params = {
      ...searchedParams,
      page: 0,
      status: status.id,
    };
    getData(params);
  };

  const getSurveyStatus = (status) => {
    const key = Object.keys(SurveyStatus).filter(
      (key) => SurveyStatus[key].id === status
    );
    return SurveyStatus[key]?.value;
  };

  return (
    <DefaultTable {...defaultProps}>
      <Filter>
        {t("appText.surveysTable.status")}
        <CustomDropdown
          placeholder={SurveyStatus.ALL.value}
          values={Object.values(SurveyStatus)}
          onChange={(e) => filterByAccountStatus(e)}
        />
      </Filter>
      {surveys?.map((survey, index) => (
        <Line key={index}>
          <span>{survey?.title}</span>
          <span>
            {survey?.expires
              ? moment(survey?.expires).format(DateFormat.BASE_FORMAT)
              : "-"}
          </span>
          <span>{`${survey?.estimatedTime} min` ?? ""}</span>
          <span>
            {survey?.createdAt
              ? moment(survey?.createdAt).format(DateFormat.BASE_FORMAT)
              : ""}
          </span>
          <span>{getSurveyStatus(survey?.statusId)}</span>
          <TableDropDown>
            {getDropDownItems(survey)
              .filter((dropDownItem) => dropDownItem.isVisible)
              .map((item, index) => (
                <Dropdown.Item
                  key={index}
                  bsPrefix="dropdown-item"
                  disabled={item.isDisabled}
                  onSelect={() => item.callBack(survey)}
                >
                  {item.text}
                </Dropdown.Item>
              ))}
          </TableDropDown>
        </Line>
      ))}
    </DefaultTable>
  );
};

export default withTheme(SurveysTable);
